export type AspectRatio = 'square' | 'portrait' | 'landscape'

export const getAspectRatio = (width?: number, height?: number): AspectRatio => {
  if (width === undefined || height === undefined || width === height) {
    return 'square'
  }

  return width > height ? 'landscape' : 'portrait'
}
